<template>
  <div class="page-filter">
    <div class="page-filter-item-wrap" v-for="item in data" :key="item.name">
      <div class="page-filter-item" v-if="item.list && item.list.length">
        <label class="page-filter-label">{{ item.name }}</label>
        <div
          class="page-filter-btn-wrapper"
          :class="btnWrapperClass(item, item.subList && item.subList.length)">
          <lr-link
            class="page-filter-btn"
            v-for="subItem in item.list"
            :key="subItem.value"
            :to="subItem.url"
            :class="{ active: item.value === subItem.value }"
            @click="$emit('first-click', item, subItem)"
            :target="subItem.target"
            >{{ subItem.name }}
          </lr-link>
        </div>
      </div>
      <!-- 子列表有数据才展示 -->
      <div
        class="page-filter-item second"
        v-if="item.subList && item.subList.length"
      >
        <div class="page-filter-btn-wrapper" :class="btnWrapperClass(item)">
          <div class="page-filter-btn-wrapper-border">
            <lr-link
              class="page-filter-btn"
              v-for="subItem in item.subList"
              :key="subItem.value"
              :to="subItem.url"
              :class="{ active: item.subValue === subItem.value }"
              @click="$emit('second-click', item, subItem)"
              :target="subItem.target"
              >{{ subItem.name }}
            </lr-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      // 数据结构如下
      default: () => [
        {
          name: '',
          value: '', // 列表当前选定值
          subValue: '', // 子列表当前选定值
          list: [{ name: '', value: '', url: '', target: '' }], // 列表数据
          subList: [{ name: '', value: '', url: '', target: '' }], // 子列表数据
          hasBackground: false, // 是否需要添加背景色样式
        },
      ],
    },
  },
  methods: {
    btnWrapperClass(item, changeBorder) {
      return {
        'wrap-background': item.hasBackground,
        'boder-fix': changeBorder
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.page-filter {
  box-sizing: border-box;

  .wrap-background {
    background: #f2f3f5;
    border-radius: 4px;
    padding: 7px 12px;
    .page-filter-btn.active {
      color: #2c71fa;
      background: #F0F9FF;
      &:active:not(:disabled) {
        background: #F0F9FF;
      }
    }
    .page-filter-btn {
      color: #6D7582;
    }
  }
  .boder-fix {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-top: -4px;
  }

  &-item-wrap {
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  &-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    &.second {
      margin-left: 54px;
      .wrap-background {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        padding: 0 12px;
      }
    }
  }
  &-label {
    width: 54px;
    font-size: 14px;
    font-weight: bold;
    color: #111317;
    line-height: 24px;
  }
  &-btn-wrapper {
    display: flex;
    flex-flow: row wrap;
    flex: 1;
    &-border {
      width: 100%;
      display: flex;
      flex-flow: row wrap;
      border-top: 1px solid rgba(17, 19, 23, 0.05);
      padding: 7px 0;
    }
  }
  &-btn {
    font-size: 14px;
    color: #333840;
    line-height: 24px;
    padding: 0px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      background: rgba(8, 48, 93, 0.04);
      border-radius: 4px;
    }

    &:active:not(:disabled) {
      background: rgba(8, 48, 93, 0.08);
      color: #333840;
    }

    &.active {
      background: #e6effc;
      border-radius: 4px;
      color: #2c71fa;

      &:hover,
      &:active:not(:disabled) {
        background: #e6effc;
        color: #2c71fa;
      }
    }
  }
}
</style>
